import React, { Component } from "react";
import s from "./styles.scss";
import { Styled, RouterProps } from "../../../toolkit/decorators/Artifact";
import { Preview } from "../../../types/IAction";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./ExpedienteValidacion.form";
import ExpedienteValidacionTable from "./ExpedienteValidacion.table";
import ExpedienteVisor from "../expedientsV2visor/index";
import {
  errorNotification,
  infoNotification,
  successNotification,
  warnNotification
} from "../../../utils/notifications";
import {
  ExpedienteValidacionStore,
  GetCondensados,
  PutAutorizar
} from "../../containers/expedientesMembresiasValidacion/ExpedienteValidacion.store";
import { ExpedienteValidacionDispatcher } from "../../containers/expedientesMembresiasValidacion/ExpedienteValidacion.dispatcher";

interface Props
  extends ExpedienteValidacionStore,
    ExpedienteValidacionDispatcher,
    RouterProps {
  userContext?: any;
}

interface State {
  page: number;
  filters: any;
  visor: boolean;
  idMembresiaSocio: string;
}

@Styled(s)
export default class ExpedienteValidacionComponent extends Component<
  Props,
  State
> {
  state = {
    page: 0,
    filters: null,
    visor: false,
    idMembresiaSocio: ""
  };

  fetchData = options => {
    if (this.state.filters && this.state.filters.idClub) {
      this.submit(this.state.filters, options.page);
    }
  };

  submit = async (values: { [key in Inputs]: any }, pageArg?: number) => {
    const page = pageArg || 0;

    const tipoBusqueda = values.tipoBusqueda || "";

    let filters: any;

    if (tipoBusqueda === "FACTURA") {
      // Búsqueda por factura
      filters = {
        folioFactura: values.folioFactura
      };
    } else if (tipoBusqueda === "MEMBRESIA") {
      // Búsqueda por membresía
      filters = {
        idClub: Number(values.idClubMembresia) || 0,
        idPublico: Number(values.idPublico) || 0
      };
    } else {
      // Búsqueda por fechas (default)
      filters = {
        idClub: Number(values.idClubFecha) || 0,
        fechaInicio: values.fechaInicio,
        fechaFin: values.fechaFin,
        ignorarAut: values.ignorarAut || false
      };
    }

    this.setState({ page, filters });

    const preview: Preview<GetCondensados> = await this.props.getCondensados({
      ...filters,
      pagina: page
    });

    if (!preview.fulfilled) {
      errorNotification("Error al realizar la búsqueda solicitada");
    } else if (!preview.condensados || !preview.condensados.totalElements) {
      warnNotification("No se encontraron expedientes para su búsqueda");
    } else {
      successNotification("Búsqueda finalizada correctamente");
    }
  };

  goToMembresia = ({ idMembresiaSocio, idClub, idPublico }) => {
    window.open(
      `membresias-socios/${idMembresiaSocio}?idClub=${idClub}&idPublico=${idPublico}`,
      "_blank"
    );
  };

  autorizar = async row => {
    infoNotification("Autorizando el expediente");
    const preview: Preview<PutAutorizar> = await this.props.putAutorizar(
      row.idExpediente
    );

    if (preview.fulfilled) {
      successNotification("Expediente autorizado correctamente");

      if (this.state.filters.ignorarAut) {
        this.submit(this.state.filters, this.state.page);
      }
    }
  };

  openExpediente = row => {
    this.setState({
      visor: true,
      idMembresiaSocio: row.idMembresiaSocio
    });
  };

  closeExpediente = () => {
    this.setState({ visor: false });

    if (this.state.filters && this.state.filters.ignorarAut) {
      this.submit(this.state.filters);
    }
  };

  render() {
    return (
      <>
        {/* Formulario de búsqueda */}
        <div style={{ margin: "0 15px" }}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.submit}
            processing={this.props.condensadosLoading}
            init={
              {
                ignorarAut: true,
                idClubMembresia: this.props.userContext
                  ? this.props.userContext.clubSessionId || ""
                  : ""
              } as any
            }
          />
        </div>

        {/* Tabla */}
        {this.props.condensados && (
          <ExpedienteValidacionTable
            condensados={this.props.condensados}
            loading={this.props.condensadosLoading}
            page={this.state.page}
            onFetchData={this.fetchData}
            goToMembresia={this.goToMembresia}
            openExpediente={this.openExpediente}
            autorizar={this.autorizar}
          />
        )}

        {/* Visor de documentos */}
        {this.renderVisor()}
      </>
    );
  }

  renderVisor = () => {
    if (this.state.visor) {
      return (
        <ExpedienteVisor
          idMembresiaSocio={this.state.idMembresiaSocio}
          onClose={this.closeExpediente}
        />
      );
    } else {
      return <></>;
    }
  };
}
